import { h } from 'preact'
//import Moment from 'moment'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const CTA = (props) => {
  let title = props.ctaTitle ? props.ctaTitle : "Mars";
  let subtitle = props.ctaSubtitle ? props.ctaSubtitle : "The digital artists";
  let content = props.ctaContent ? props.ctaContent : "";
  let buttonUrl = props.ctaButtonUrl ? props.ctaButtonUrl : '#';
  let buttonContent = props.ctaButtonContent ? props.ctaButtonContent : 'Maak een afspraak';

  return (
    <div className="c-portfolio-cta">
      <div className="c-portfolio-cta__title">{ title }</div>
      <div className="c-portfolio-cta__subtitle">{ subtitle }</div>
      <div className="c-portfolio-cta__content">{ content }</div>

      <div className="c-portfolio-cta__button-container">
        <a href={ buttonUrl } className="c-portfolio-cta__button">{buttonContent}</a>
      </div>
    </div>
  )
}

export default CTA


// WEBPACK FOOTER //
// ./src/js/app/components/Cta.js